// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FirstStepper_container__Y5dbA {
  display: flex;
  justify-content: center;
}

.FirstStepper_container__Y5dbA .FirstStepper_init1__fz0VC {
  animation: FirstStepper_init__CBxJs 0.3s 0.5s both;
}

.FirstStepper_container__Y5dbA .FirstStepper_init2__Bk\\+Re {
  animation: FirstStepper_init2__Bk\\+Re 0.3s 0.3s both;
}

@keyframes FirstStepper_init__CBxJs {
  0% {
    opacity: 0;
    transform: translateX(-30px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes FirstStepper_init2__Bk\\+Re {
  0% {
    opacity: 0;
    transform: translateX(30px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Remitos/Create/Steppers Refactor/FirstStepper/FirstStepper.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kDAA8B;AAChC;;AAEA;EACE,oDAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n}\n\n.container .init1 {\n  animation: init 0.3s 0.5s both;\n}\n\n.container .init2 {\n  animation: init2 0.3s 0.3s both;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateX(-30px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    transform: translateX(30px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FirstStepper_container__Y5dbA`,
	"init1": `FirstStepper_init1__fz0VC`,
	"init": `FirstStepper_init__CBxJs`,
	"init2": `FirstStepper_init2__Bk+Re`
};
export default ___CSS_LOADER_EXPORT___;
